export const TARGET_BLOCK_RULES = {
  source_self: { id: "TRG-001", summary: "Source cannot target itself" },
  same_role_scope: {
    id: "TRG-002",
    summary: "Target in same role scope is excluded",
  },
  connection_member: {
    id: "TRG-003",
    summary: "Existing connection participants cannot be re-targeted",
  },
  connection_role_scope: {
    id: "TRG-004",
    summary: "Roles already represented in source connection are excluded",
  },
  refinement_crossing_scope: {
    id: "TRG-005",
    summary: "Refinement crossing constraints exclude target",
  },
  state_connection_scope: {
    id: "TRG-006",
    summary: "State source excludes already-connected interaction scope",
  },
  state_temporal_ancestor: {
    id: "TRG-007",
    summary: "State source excludes temporal ancestors",
  },
  state_temporal_successor: {
    id: "TRG-008",
    summary: "State source excludes temporal successors",
  },
  unimplemented_repeat: {
    id: "TRG-009",
    summary: "Repeat-source targeting rules are not implemented",
  },
  excluded_by_connection_rules: {
    id: "TRG-010",
    summary: "Connection-source target excluded by connection constraints",
  },
  excluded_by_role_rules: {
    id: "TRG-011",
    summary: "Role-source target excluded by role constraints",
  },
  excluded_by_state_rules: {
    id: "TRG-012",
    summary: "State-source target excluded by state constraints",
  },
  excluded_by_case_rules: {
    id: "TRG-013",
    summary: "Case-source target excluded by case constraints",
  },
  excluded_by_part_rules: {
    id: "TRG-014",
    summary: "Part-source target excluded by part constraints",
  },
  excluded_by_activity_rules: {
    id: "TRG-015",
    summary: "Activity-source target excluded by activity constraints",
  },
};

export const TARGET_BLOCK_RULE_TEXT = {
  "TRG-001": "Cannot connect an element to itself.",
  "TRG-002": "Target is in the same role scope as the source.",
  "TRG-003": "Target is already a member of the source connection.",
  "TRG-004": "Target role is already represented in the source connection.",
  "TRG-005":
    "Target is blocked to avoid crossing refinement thread interactions.",
  "TRG-006":
    "Target interaction is already connected to the source role scope.",
  "TRG-007": "Target is excluded by temporal ancestor constraints.",
  "TRG-008": "Target is excluded by temporal successor constraints.",
  "TRG-009": "Repeat-thread target rules are not implemented yet.",
  "TRG-010": "Target is excluded by connection-level constraints.",
  "TRG-011": "Target is excluded by role-level constraints.",
  "TRG-012": "Target is excluded by state-level constraints.",
  "TRG-013": "Target is excluded by case-level constraints.",
  "TRG-014": "Target is excluded by part-level constraints.",
  "TRG-015": "Target is excluded by activity-level constraints.",
  "TRG-000": "Invalid connection target selected.",
};

export const getTargetBlockRule = (reason) => TARGET_BLOCK_RULES[reason] ?? null;

export const resolveBlockedRuleId = (reason) =>
  TARGET_BLOCK_RULES[reason]?.id ?? "TRG-000";
